export const CLASSIFIEDS_DEFAULT_ORDER_ID = 'NEWEST_AD';
